import { useRef } from "react";
import { axiosRequestData } from "../helpers/axios";
import { Accelerator } from "../interfaces/accelerator";
import { Course } from "../interfaces/course";
import { Lesson } from "../interfaces/lesson";
import { trainingCourseAllVideosWatched } from "../components/mixPanelEvents/mixPanelEvents";

// Custom hook for video progress tracking
export const useVideoProgressTracking = (currentLesson: any, accelerator: Accelerator) => {
    const lastUpdateRef = useRef(0);
    const allVideosWatchedRef = useRef(false);
    const UPDATE_INTERVAL = 10000; // 1 second interval, adjust as needed

  const sendProgressUpdate = async (progress: number) => {
    try {
        const response = await axiosRequestData(
            "POST",
            `/wp-json/pg/v2/lesson/${currentLesson.ID}/progress`,
            { progress, courseID: accelerator.ID }
        );
        currentLesson.video.progress = progress;
        return response;
		} catch (error) {
			console.error('Error sending progress update:', error);
		}
    };

	const userStartedAllLessons = async () => {

		if (allVideosWatchedRef.current) {
			return true;
		}

		if (allVideosWatchedRef.current) {
			return true;
		}

		if (accelerator.courses.length === 0) {
			return false;
		}

		const allLessonsFromCourse: Lesson[] = [];
		accelerator.courses.forEach((course: Course) => {
			course.lessons.forEach((lesson: Lesson) => {
				if (lesson.lesson_type === "video" && !lesson.is_introduction) {
					allLessonsFromCourse.push(lesson);
				}
			});
		});

		const allLessonsHave50PercentOrMore = allLessonsFromCourse.every((lesson: Lesson) =>
			lesson.video.progress >= Number(lesson.video.duration) * 0.5
		);

		console.log(" All lessons 50%+:", allLessonsHave50PercentOrMore);

		if (allLessonsHave50PercentOrMore && !allVideosWatchedRef.current) {
			allVideosWatchedRef.current = true;
			const res = await axiosRequestData("POST", "/wp-json/pg/v1/user/allvideoswatched", {
				course: accelerator.name,
			});
			if (!res.data?.already_watched) {
				trainingCourseAllVideosWatched(currentLesson, accelerator);
			}
		}

		return allLessonsHave50PercentOrMore;
	}

	const onProgressUpdate = (event: { seconds: number; duration: number; percent: number }) => {
        const currentTime = Date.now();
		// console.log("percent is >>>> ", event.percent)
		if (event.seconds < 1 || event.percent < 0.01) {
			return;
		}

        if (currentTime - lastUpdateRef.current >= UPDATE_INTERVAL) {
            sendProgressUpdate(event.seconds);

            // After crossing 50%, check if all videos are also 50%+ complete
            if (event.percent >= 0.5) {
                userStartedAllLessons();
            }

            lastUpdateRef.current = currentTime;
        }
    };

	return {
		onProgressUpdate,
		userStartedAllLessons
	};
};